import React from 'react'
import PropTypes from 'prop-types'

const IconWithCount = ({ object, count, redirectLink, dataAttr, onClick }) => {
  return (
    <div onClick={onClick} className={`item ${object ? ` ${object}` : ''}`}>
      <a href={redirectLink} data-attr={dataAttr}>
        {count}
      </a>
    </div>
  )
}

IconWithCount.propTypes = {
  object: PropTypes.string,
  count: PropTypes.number,
  redirectLink: PropTypes.string,
  dataAttr: PropTypes.string,
  onClick: PropTypes.func
}

export default IconWithCount
